import React, { useState } from "react";
import "./../../assets/css/Leads/LeadDynamic.css";
import FollowUpModal from "../FollowUp/FollowUpModal";
import DealsCreate from "../Deals/DealsCreate";

import {
  FaCalendarAlt,
  FaTags,
  FaMoneyBillWave,
  FaPhoneAlt,
  FaUserTie,
} from "react-icons/fa";

import { MdOutlineEmail, MdBusiness } from "react-icons/md";

export default function LeadsDynamic({
  leads = [],
  title = "Leads",
  onLeadClick,
  onFollowupSuccess,
}) {
  const [selectedLeadForFollowup, setSelectedLeadForFollowup] = useState(null);
  const [showDealModal, setShowDealModal] = useState(false);
  const [pendingFollowup, setPendingFollowup] = useState(null);

  const currentUser = JSON.parse(sessionStorage.getItem("user"));
  const userRole = currentUser?.role?.toLowerCase()?.trim()?.replace(/\s+/g, "_");
  const isLeadGenerator = userRole === "lead_generator";
  console.log(isLeadGenerator);

  const isTerminalLeadStatus = (status = "") => {
    if (!status) return false;
    const s = String(status).toLowerCase().trim();
    return (
      s === "won" ||
      s === "lost" ||
      s === "closed" ||
      s === "close" ||
      s === "converted" ||
      s === "deal confirmation" ||
      s.includes("won") ||
      s.includes("lost") ||
      s.includes("close") ||
      s.includes("cancel")
    );
  };

  const getStatusClass = (status = "") => {
    const s = status.toLowerCase();
    if (s === "new" || s === "converted") return "new";
    if (s.includes("lost") || s.includes("cancel")) return "lost";
    if (s.includes("proposal") || s.includes("negotiation") || s.includes("qualified")) return "pending";
    return "default";
  };

  return (
    <div className="ld-wrap">
      {/* TOPBAR */}
      <div className="ld-topbar">
        <div className="ld-topbar-left">
          <h2>{title}</h2>
          <span className="ld-count">{leads.length}</span>
        </div>
      </div>

      {/* GRID */}
      <div className="ld-grid">
        {leads.length === 0 ? (
          <div className="ld-empty-state">
            <div className="ld-empty-icon">
              <FaUserTie />
            </div>
            <h4>No leads found</h4>
            <p>There are currently no active leads associated with this record.</p>
          </div>
        ) : (
          leads.map((lead) => {
            const statusStyle = getStatusClass(lead.status);
            const isTerminal = isTerminalLeadStatus(lead.status);
            return (
              <div
                className="ld-card"
                key={lead.id}
                onClick={() => onLeadClick?.(lead)}
              >
                {/* HEADER */}
                <div className="ld-card-head">
                  <div className="ld-head-left">
                    <div className="ld-avatar">
                      {lead.title?.charAt(0) || "L"}
                    </div>

                    <div className="ld-title-block">
                      <div className="ld-title-row">
                        <h3>{lead.title || "Untitled Lead"}</h3>
                        {(lead.organization_name || lead.organization?.name) && (
                          <span className="ld-org-badge" title="Organization">
                            <MdBusiness className="ld-org-badge-icon" />
                            <span>{lead.organization_name || lead.organization?.name}</span>
                          </span>
                        )}
                      </div>
                      <p>{lead.lead_type || "No type"}</p>
                    </div>
                  </div>

                  <span
                    className={`ld-status ${lead.status === "New" ? "new" : "default"} ld-status-${statusStyle}`}
                  >
                    <span className="ld-status-dot"></span>
                    {lead.status || "New"}
                  </span>
                </div>

                {/* CHIPS */}
                <div className="ld-chips">
                  {(lead.organization_name || lead.organization?.name) && (
                    <span className="ld-chip-org" title="Organization">
                      <MdBusiness className="ld-chip-icon" />{" "}
                      {lead.organization_name || lead.organization?.name}
                    </span>
                  )}

                  <span>
                    <FaTags className="ld-chip-icon" /> {lead.lead_type || "-"}
                  </span>

                  <span>
                    <FaMoneyBillWave className="ld-chip-icon" />{" "}
                    {typeof lead.value === "number"
                      ? `₹${lead.value.toLocaleString("en-IN")}`
                      : lead.value || "-"}
                  </span>

                  {lead.email && (
                    <span className="ld-chip-email">
                      <MdOutlineEmail className="ld-chip-icon" /> Email
                    </span>
                  )}

                  {lead.contact_name && (
                    <span className="ld-chip-contact">
                      <FaUserTie className="ld-chip-icon" /> {lead.contact_name}
                    </span>
                  )}
                </div>

                {/* DESCRIPTION */}
                <div className="ld-desc">
                  {lead.description || "No description provided"}
                </div>

                {/* FOOTER */}
                <div className="ld-footer">
                  <span>
                    <FaCalendarAlt className="ld-footer-icon" />
                    {lead.created_at
                      ? new Date(lead.created_at).toLocaleDateString()
                      : "-"}
                  </span>

                  {!isTerminal && !isLeadGenerator && (
                    <button
                      type="button"
                      className="ld-followup-btn"
                      onClick={(e) => {
                        e.stopPropagation();
                        setSelectedLeadForFollowup(lead);
                      }}
                      title="Log / View Follow Up"
                    >
                      <FaPhoneAlt size={10} />
                      <span>Follow Up</span>
                    </button>
                  )}
                </div>
              </div>
            );
          })
        )}
      </div>

      {/* FOLLOW UP MODAL */}
      {selectedLeadForFollowup && (
        <FollowUpModal
          type="lead"
          id={selectedLeadForFollowup.id}
          lead={selectedLeadForFollowup}
          isOpen={Boolean(selectedLeadForFollowup) && !showDealModal}
          onClose={() => {
            setSelectedLeadForFollowup(null);
            setPendingFollowup(null);
          }}
          onSuccess={async (followupResult) => {
            if (followupResult?.isPendingDealConfirmation) {
              setPendingFollowup(followupResult.pendingFollowup || followupResult);
              setShowDealModal(true);
              return;
            }
            setSelectedLeadForFollowup(null);
            onFollowupSuccess?.();
          }}
        />
      )}

      {showDealModal && selectedLeadForFollowup && (
        <DealsCreate
          isOpen={showDealModal}
          lead={selectedLeadForFollowup}
          pendingFollowup={pendingFollowup}
          isConversionFlow={true}
          onClose={() => {
            setShowDealModal(false);
            setPendingFollowup(null);
            setSelectedLeadForFollowup(null);
          }}
          onSuccess={async () => {
            setShowDealModal(false);
            setPendingFollowup(null);
            setSelectedLeadForFollowup(null);
            onFollowupSuccess?.();
          }}
        />
      )}
    </div>
  );
}